/**
 * Path della route login (include PUBLIC_URL se la build è servita da subpath).
 */
export function getLoginPath(): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return base ? `${base}/login` : '/login';
}

export function isLoginPathname(pathname: string): boolean {
  const normalized = pathname.replace(/\/$/, '') || '/';
  const login = getLoginPath().replace(/\/$/, '') || '/login';
  return normalized === login;
}
